import useShop from '@hooks/shop/useShop';
import useProject from '@hooks/useProject';

function useOrderEnabled(shopId: string) {
    const project = useProject();
    const shop = useShop(shopId);
    return project?.features.orderEnabled && shop?.shopStatus === 'REGISTERED';
}

export default useOrderEnabled;
